<template>
    <div class="ticket-perdido-section">
        <div class="ticket-perdido-content">
            <h2 class="ticket-perdido-title fuente-posm">
                ¿El Cliente Perdió su Ticket?
            </h2>
            <p class="ticket-perdido-text fuente-nova">
                No te preocupes, también tenemos la solución. El cliente solicita factura manual desde el portal. Si el sistema encuentra el ticket, genera la factura automáticamente.
                <br><br>
                Si no lo encuentra, recibes un WhatsApp para aprobar la factura manual. Un agente de IA busca entre las facturas una coincidencia casi exacta para permitir al cliente facturar sin demoras.
            </p>
        </div>
        <div class="ticket-perdido-image">
            <img :src="a63" alt="Ticket perdido">
        </div>
    </div>
</template>

<script>
export default {
    name: 'TicketPerdidoNew',
    data() {
        return {
            a63: require('@/assets/images/a63.webp')
        }
    }
}
</script>

<style lang="css" scoped>
.ticket-perdido-section {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 40px 60px;
    box-sizing: border-box;
    scroll-snap-align: start;
    gap: 40px;
}

.ticket-perdido-image {
    flex: 0 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    order: 2;
}

.ticket-perdido-image img {
    width: 400px;
    height: auto;
}

.ticket-perdido-content {
    flex: 1;
    max-width: 700px;
    order: 1;
}

.ticket-perdido-title {
    color: var(--color-2);
    font-size: 68px;
    line-height: 1.1;
    margin: 0 0 20px 0;
}

.ticket-perdido-text {
    color: var(--color-3);
    font-size: 29px;
    line-height: 1.3;
    margin: 0;
    padding-left: 10px;
}

/* Tablet */
@media (max-width: 992px) and (min-width: 769px) {
    .ticket-perdido-title {
        font-size: 60px;
    }

    .ticket-perdido-text {
        font-size: 27px;
    }

    .ticket-perdido-image img {
        width: 320px;
    }
}

/* Mobile */
@media (max-width: 768px) {
    .ticket-perdido-section {
        flex-direction: column;
        justify-content: flex-start;
        height: 100vh;
        padding: 100px 20px 40px 20px;
        gap: 20px;
    }

    .ticket-perdido-content {
        order: 1;
        max-width: 100%;
        flex: none;
    }

    .ticket-perdido-image {
        order: 2;
        width: 100%;
        flex: 1;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        padding-top: 20px;
    }

    .ticket-perdido-image img {
        width: 80%;
        max-width: 320px;
    }

    .ticket-perdido-title {
        font-size: 24px;
        line-height: 1.2;
        margin: 0 0 10px 0;
    }

    .ticket-perdido-text {
        font-size: 16px;
        padding-left: 10px;
        margin: 0;
    }
}
</style>
